import { GameTemplateForm } from "./form";
import { useSnackbar } from "notistack";
import { translate } from "../../../translations";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import APIclient from "../../../api-client";
import { GameTemplateParams } from "../../../api-client/game_template_module";
import { GameTemplate, Stored } from "../../../types";

export default function CreateGameTemplate() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [template, setTemplate] = useState<Stored<GameTemplate> | null>(null);
  const { id } = useParams();

  useEffect(() => {
    if (id === undefined) return;

    APIclient.gameTemplates.read(id).then(setTemplate);
  }, []);

  const updateGame = async (newTemplate: GameTemplateParams) => {
    await APIclient.gameTemplates.update(id!, newTemplate);
    enqueueSnackbar(translate("teacher.gameSettings.edit.successMessage"), {
      variant: "success",
    });
    navigate("/teacher");
  };

  return template ? (
    <GameTemplateForm template={template} submit={updateGame} />
  ) : null;
}
